import React, { useState } from 'react'
import { useNavigate, Link } from 'react-router-dom'
import '../styles/Login.css'

const BASE_URL = 'https://api.admin.yourhood.ge'  // ✅ fixed URL

function Login() {
  const [phone, setPhone] = useState('')
  const [password, setPassword] = useState('')
  const [error, setError] = useState('')
  const [isLoading, setIsLoading] = useState(false)
  const navigate = useNavigate()

  const handleLogin = async (e) => {
    e.preventDefault()
    setError('')

    if (!phone.trim() || !password.trim()) {
      setError('გთხოვთ შეავსოთ ყველა ველი')
      return
    }

    setIsLoading(true)
    try {
      const res = await fetch(`${BASE_URL}/api/Auth/login`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Language': 'ka'
        },
        body: JSON.stringify({ phonenumber: phone, password })
      })

      const data = await res.json()

      if (res.ok && data.token) {
        localStorage.setItem('token', `Bearer ${data.token}`)  // ✅ Bearer prefix stored
        localStorage.setItem('isAuthenticated', 'true')
        navigate('/admin')
      } else {
        setError('ტელეფონის ნომერი ან პაროლი არასწორია')
      }
    } catch (err) {
      setError('კავშირის შეცდომა. სცადეთ თავიდან.')
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <div className="login-container">
      <div className="login-card">
        <div className="login-header">
          <span className="login-brand">YourHood</span>
          <h1 className="login-title">ადმინ პანელი</h1>
          <p className="login-subtitle">შედით თქვენს ანგარიშზე</p>
        </div>
        <form onSubmit={handleLogin} className="login-form">
          <div className="form-group">
            <label className="label">ტელეფონის ნომერი</label>
            <input
              type="tel"
              className="input"
              placeholder="5XXXXXXXX"
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
              disabled={isLoading}
              autoComplete="tel"
            />
          </div>
          <div className="form-group">
            <label className="label">პაროლი</label>
            <input
              type="password"
              className="input"
              placeholder="••••••••"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              disabled={isLoading}
              autoComplete="current-password"
            />
          </div>
          {error && <div className="error-message">{error}</div>}
          <button type="submit" className="login-button" disabled={isLoading}>
            {isLoading ? 'შესვლა...' : 'შესვლა'}
          </button>
        </form>
        <div className="login-links">
          <Link to="/register" className="login-link">რეგისტრაცია</Link>
          <span className="login-link-sep">·</span>
          <Link to="/change-password" className="login-link">პაროლის შეცვლა</Link>
        </div>
        <div className="login-footer">
          <span className="footer-text">© 2026 YourHood · დაცული კავშირი</span>
        </div>
      </div>
    </div>
  )
}

export default Login